import React, { useEffect, useState } from 'react';
import { FaRegBell, FaUserCircle } from "react-icons/fa";
import { MdOutlineEmail, MdLogout } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import { IoReorderThree } from "react-icons/io5";
import { RiLockPasswordLine } from "react-icons/ri";
import logo from '../assest/images/rexovms.png'
import logo2 from '../assest/images/APM_Logo.jpg'
import logo3 from '../assest/images/logo.png'
import Sidebar from './Sidebar';
import UpdatePsw from '../pages/login/UpdatePsw';
import AddButton from '../component/buttons/AddButton';
import { Button } from 'react-bootstrap';
import '../assest/style/pages_css/Navbar.css';

export default function Navbar() {
    // const [adminpsw, setAdminpsw] = useState(false)

    // const handlePswUpdate = () => {
    //     setAdminpsw(true);
    // }

    let mobileScreen = window.screen.width <= 992;


    const [show, setShow] = useState(false)

    const handlePswChnge = () => {
        setShow(true)
    }

    const navigate = useNavigate();
    const logout = () => {
        localStorage.clear();
        navigate('/login');
    }

    // const [sidebar, setSidebar] = useState(true);

    var type = localStorage.getItem('type')

    // useEffect(() => {
    //     if (sidebar) {
    //         var marginAll = document.getElementById("content");
    //         marginAll.classList.add("margin-all-page")
    //     } else {
    //         var marginAll = document.getElementById("content");
    //         marginAll.classList.remove("margin-all-page")
    //     }
    // })

    return (
        <>
            <nav className='app-navbar'>
                <div className='container-fluid navbar-fixed'>
                    <header className='ps-4 pe-4' id='property-header'>
                        <div className="row  ">
                            <div className="col-md-12 p-0">
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className=" d-flex align-items-center">
                                        <Link to='/dashboard'><div className='header-logo-section ' id='header-dekstop-logo'>
                                            <img src={logo} className='img-fluid header-logo ' alt="property-logo" />
                                        </div></Link>
                                        <div>
                                        </div>
                                    </div>
                                    <div className='header-center-text'>
                                        {/* <h4 style={{color:'white',marginBottom:'0px'}}>Visitor Management System</h4> */}
                                        {/* <span style={{fontSize:'13px',color:'#42c9c4',display:'flex' ,justifyContent:'center'}}>AI-Powered Slitting Optimization</span> */}
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <p className='mb-0 me-2'>
                                            <span className='welcome-text'>
                                                {mobileScreen ? '' : "Welcome ! Admin"}
                                                <FaUserCircle size={25} className='ms-1 user-icon' />
                                            </span>
                                        </p>
                                        <Button type='button' size='sm' variant="outline-light" className='logout_btn' onClick={logout}>LOGOUT</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </div >
            </nav >


            {/* <PasswordUpdate adminpsw={adminpsw} setAdminpsw={setAdminpsw} /> */}
            <UpdatePsw show={show} setShow={setShow} />
        </>
    )
}
